import { render, staticRenderFns } from "./MemeberPolicy.vue?vue&type=template&id=4072cd8a"
import script from "./MemeberPolicy.vue?vue&type=script&lang=js"
export * from "./MemeberPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports